import React, {useEffect, useRef, useState, useMemo} from "react";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";
import RecommendedProducts from "./RecommendedProducts";
import StyleWithProducts from "./StyleWithProducts";

export const StyleWith = ({ products = [], settings, style_products = [] }) => {
    const [selectedCategory, setSelectedCategory] = useState(style_products.length > 0 ? "styleProducts" : "recommendedProducts");
    const isMobile = useMobileBreakpoint(mobileBreakpoint);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setTimeout(() => {
            // Ensure Flickity resizes after the DOM updates
            document.querySelectorAll(".carousel-recommended ").forEach((carousel) => {
                const flickityCarousel = window.Flickity?.data(carousel);
                if (flickityCarousel) {
                    flickityCarousel.resize();
                }
            });
        }, 100);
    };


    // useEffect(() => {
    //     if (!hasInitializedCarousel.current) {
    //       // Prevents re-initialization
    //       const timeout = setTimeout(() => {
    //         window.dispatchEvent(new Event("resize"));
    //       }, 2000);
    
    //       function resizeCarousel() {
    //         document.querySelectorAll(".carousel").forEach((carousel) => {
    //           const flickityCarousel = window.Flickity?.data(carousel);
    //           if (flickityCarousel) {
    //             setTimeout(() => flickityCarousel.resize(), 200);
    //           }
    //         });
    //       }
    
    //       window.addEventListener("carousel-init", resizeCarousel);
    //       resizeCarousel();
    
    //       hasInitializedCarousel.current = true; // Mark as initialized
    
    //       return () => {
    //         clearTimeout(timeout);
    //         window.removeEventListener("carousel-init", resizeCarousel);
    //       };
    //     }
    //   }, []);

    settings.show_quickadd = settings.section.product_tile_quickadd_show;
    settings.show_price = settings.section.product_tile_price_show;
    settings.show_tags = settings.section.product_tile_tag_show;

    let headingClass = "h3 cursor-pointer";

    if (isMobile) {
        headingClass = "h3";
    }

    return (
        <>
            {(products.length > 0 || style_products.length > 0) && (
                <div className="container recommendedproducts lg:px-[106px]">

                    <div className="recommendedproducts__header">
                        <div className="flex items-center mb-4 justify-center w-full">
                            {style_products.length > 0 && (
                                <div
                                    className={`basis-1/2 lg:basis-auto lg:px-[24px]`}
                                >
                                    <div
                                        className={`${headingClass} ${selectedCategory === "styleProducts" ? "selected text-black" : "text-gray-200"}`}
                                        onClick={() => handleCategoryClick("styleProducts")}
                                    >
                                        STYLE WITH
                                    </div>
                                </div>
                            )}
                            {products.length > 0 && (
                                <div
                                    className={
                                        "basis-1/2 lg:basis-auto lg:px-[24px] carousel-tab-header"
                                    }
                                >
                                    <div
                                        className={`${headingClass} ${selectedCategory === "recommendedProducts" ? "selected text-black" : "text-gray-200"}`}
                                        onClick={() => handleCategoryClick("recommendedProducts")}
                                    >
                                        RECOMMENDED
                                    </div>
                                </div>
                            )}
                            <div className="flex-1 border-b border-gray-300 hidden lg:hidden"></div>
                        </div>
                    </div>
                    <div className={selectedCategory === "styleProducts" ? "opacity-100 z-10" : "opacity-0 z-0 absolute"}>
                        <StyleWithProducts products={style_products} settings={settings} />
                    </div>
                    <div className={selectedCategory === "recommendedProducts" ? "opacity-100 z-10" : "opacity-0 z-0 absolute"}>
                        <RecommendedProducts products={products} settings={settings} />
                    </div>
                </div>
            )}
        </>
    );
};

export default StyleWith;
